import * as React from 'react';
import { Link } from 'react-router-dom';
import { MdTranslate, MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { routeConstants } from 'app/routes/route-constants';
import { When } from './when';
import { MenuAccess } from '../../../types';
import styles from '../mobile-nav.scss';

interface Props {
  translation: any;
  menuAccess: MenuAccess;
  onItemClick: () => void;
}

export const ToolsTranslationsMenuItem = ({ translation, menuAccess, onItemClick }: Props) => (
  <When condition={menuAccess.textConfiguration}>
    <li>
      <input type="checkbox" id="mobile-admin-translations" />

      <div className={`${styles.dropdownButton} list-group-item`}>
        <MdTranslate className={styles.navItemIcon} />
        <span className={`${styles.navItemText} ${styles.small}`}>
          {translation.translations}
        </span>
        <label className={styles.dropdownLabel} htmlFor="mobile-admin-translations">
          <MdKeyboardArrowDown className={styles.down} />
          <MdKeyboardArrowUp className={styles.up} />
        </label>
      </div>

      <ul className={styles.subMenu}>
        <li className={styles.child} onClick={onItemClick}>
          <Link to={routeConstants.textConfigurationList} className="list-group-item">
            <span className={styles.navItemText}>
              {translation.texts}
            </span>
          </Link>
        </li>
        <li className={styles.child} onClick={onItemClick}>
          <Link to={routeConstants.codeDescriptionList} className="list-group-item">
            <span className={styles.navItemText}>{translation.code_descriptions}</span>
          </Link>
        </li>
      </ul>
    </li>
  </When>
);
